import _ from 'underscore';
import $ from 'jquery';
import '@bingads-webui/kendo/kendo.window';

const windowDefaults = {
  modal: true,
  maxWidth: 600,
  resizable: false,
  visible: false,
  title: '',
};

function applyIfExists(func, context, args) {
  if (_.isFunction(func)) {
    const parameters = _.toArray({ 0: args });
    func.apply(context, parameters);
  }
}

/**
 * decorate view function
 * @param {object} view - the decorated view
 * @param {Object} dialogOptions - dialog options
 * @returns {Object} DecoratedView - view after decorated
 */
export function decorate(view, dialogOptions) {
  class DecoratedView extends view {
    initialize(options) {
      this.options = options;
      this.destroy = this.remove;
      if (!_.has(view.prototype, 'render')) {
        this.show();
      }
      applyIfExists(view.prototype.initialize, this, this.options);
    }

    render() {
      this.show();
      applyIfExists(view.prototype.render, this, this.options);
      this.setPosition();

      return this;
    }

    setPosition() {
      if (this.dialogOptions.position === 'center') {
        this.center();
      }
    }

    show() {
      const options = _.defaults({
        title: this.options.title,
        autoFocus: true,
        animation: false,
      }, this.options.dialogOptions, dialogOptions, windowDefaults);

      if (!this.window) {
        this.window = this.$el
          .kendoWindow(options)
          .data('kendoWindow');
      }

      this.window.wrapper.attr('role', 'dialog');
      this.window.wrapper.attr('aria-label', options.title);
      this.window.wrapper.addClass('legacy-kendo-ui-dialog');
      this.window.center();
      this.window.open();

      const title = $('.k-window-title', this.window.wrapper);
      if (options.titleHeadingLevel) {
        title.attr({
          role: 'heading',
          'aria-level': options.titleHeadingLevel,
        });
      }

      const closeButton = $('.k-window-action.k-link', this.window.wrapper);
      closeButton.addClass('clickable');
      closeButton.attr('aria-label', options.closeButtonAriaLabel);

      const closeIcon = $('span.k-icon.k-i-close', this.window.wrapper);
      closeIcon.html('').click(_.bind(this.remove, this));

      this.window.element.attr('tabindex', -1);

      _.each(options.dialogClasses, (className) => {
        this.window.element.addClass(className);
      }, this);

      if (options.zindex) {
        this.$el.css('z-index', options.zindex);
      }

      if (!_.isEmpty(options.popupFront)) {
        const element = $(options.popupFront);
        if (element && element.length > 0) {
          const topzindex = parseInt(element.css('z-index'), 10) + 2;
          const kwindow = $('.k-window');
          const koverlay = $('.k-overlay');

          if (kwindow && kwindow.length > 0) {
            kwindow.css('z-index', topzindex);
          }
          if (koverlay && koverlay.length > 0) {
            koverlay.css('z-index', topzindex - 1);
          }
        }
      }

      this.dialogOptions = options;

      return this;
    }

    center() {
      if (this.window) {
        this.window.center();
      }
      return this;
    }

    hide() {
      if (this.window) {
        this.window.close();
      }
      return this;
    }

    remove(e) {
      if (e) {
        e.preventDefault();
      }

      applyIfExists(view.prototype.remove, this, this.options);
      applyIfExists(view.prototype.destroy, this, this.options);

      if (this.window) {
        this.window.close();
        this.window.destroy();
        this.window = null;
      }
    }
  }
  return DecoratedView;
}
